import {inject, Injectable} from "@angular/core";
import {SearchQuery, SearchResult} from "../models/search";
import {Observable} from "rxjs";
import {SearchApiService} from "../generated-sources/api";


@Injectable({
    providedIn: "root"
})
export class SearchService {
    private readonly searchApiService = inject(SearchApiService);

    constructor( ) { }

    search(searchQuery: SearchQuery): Observable<SearchResult[]> {
        return this.searchApiService.search(searchQuery);
    }
}
